var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-checkbox',{class:_vm.inputClass,attrs:{"state":_vm.state,"checked":_vm.checked,"disabled":_vm.readonly,"value":_vm.value,"indeterminate":_vm.inter,"switch":_vm.useSwitch}},[_vm._v("\n\t"+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }